import { storage } from 'APP/packages/storage';

export function resetOnboarding(): void {
  storage.onboarding.set([]);
}
